<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="!isFormDisplayed()" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: isFormDisplayed() }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !isFormDisplayed(), 'events-active': isFormDisplayed() }"
            class="detail-header">
            <app-list-header
                [createRight]="false"
                titleText="Groupes d'utilisateurs"
                createIconText="Ajouter un groupe"
                [buttonDisplayListVisible]="isTreeDisplayed()"
                [buttonDisplayTreeVisible]="isListDisplayed()"
                (exported)="onGroupsExported()"
                (helped)="onGroupsHelped()"
                (listDisplayed)="setDisplayMode(DisplayMode.List)"
                (treeDisplayed)="setDisplayMode(DisplayMode.Tree)"></app-list-header>
        </mat-expansion-panel-header>

        @if (isListDisplayed()) {
            <app-groups-list
                (itemSelected)="onGroupSelected($event)"
                (itemDisplayed)="onGroupDisplayed($event)"
                (itemEdited)="onGroupEdited($event)"
                (itemReseted)="onGroupReseted($event)"></app-groups-list>
        } @else {
            <app-groups-tree
                [isDisplayUser]="false"
                (groupDisplayed)="onGroupDisplayed($event)"
                (groupEdited)="onGroupEdited($event)"
                (groupReseted)="onGroupReseted($event)"></app-groups-tree>
        }
    </mat-expansion-panel>

    @if (isFormDisplayed()) {
        <mat-expansion-panel [expanded]="isFormDisplayed()" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.groupContext.item.getDisplayName()"
                    [id]="context?.groupContext.item.id"
                    (edited)="onGroupEdited(context?.groupContext.item)"
                    (displayed)="onGroupDisplayed(context?.groupContext.item)"
                    (helped)="onGroupsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-group-detail
                [context]="context"
                (groupUpdated)="groupUpdated($event)"
                (paramsValuesUpdated)="paramsValuesUpdated($event)"
                (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                (viewsAccessibilitiesUpdated)="onViewsAccessibilitiesUpdated($event)"
                (canceled)="onBackToList()"></app-group-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
